import { useIsAuthenticated, useMsal } from '@azure/msal-react'
import { Box, HStack, Image, Stack, Text } from '@chakra-ui/react'
import React, { useState } from 'react'
import { useEffect } from 'react'
import { AiOutlineCluster, AiOutlineCompass, AiOutlineFundProjectionScreen, AiOutlineHome, AiOutlineLogout, AiOutlineProject } from "react-icons/ai"
import { Link,useLocation, useNavigate } from 'react-router-dom'
import { isActive } from '../Authetication'
import { NavList } from './NavList'



export default function SideBar() {

    const location = useLocation();

    const List = NavList(location);

    const isAuthenticated = useIsAuthenticated()
    const navigate = useNavigate();
    const {instance} = useMsal();
    const Logout = ()=>{
        localStorage.clear("accessToken")
        localStorage.clear("ImsToken")
        instance.logoutRedirect({
            scopes: ['user.read']
        }) 
       
    }

    if(isAuthenticated == false){
        navigate("/")
     }

    

    return (

        <Box mx="15px" pb="10px" h={"100%"} overflowY={"auto"} bgColor={"gray.gray200"} w='300px' borderRadius="8px"  >

            <Image w="100px" mt={"15px"} ml={"10px"} src="./logo.jpg" />
            <Stack spacing={"15px"}  mt="32px">

                {
                    List?.filter(item => item.display === true)
                    .map((item, i) => (
                        <Link to={item.link}>
                        <HStack  bgColor={item.active ? "blue.blue100": "gray.gray200" } padding={"8px"} fontFamily="body" fontSize={"14px"} transition="2s ease in" fontWeight={"500"} color={item.active ? "#fff": "black" } _hover={{ bgColor: "blue.blue100", borderRightRadius: "2px", color: "#fff"}} key={i} cursor="pointer">
                            <Box  fontSize={"20px"} pos="relative" top="-1px">{item.icon}</Box>
                            <Text textTransform={"capitalize"}>{item.name}</Text>
                        </HStack>
                        </Link>
                    ))
                }

                <HStack onClick={Logout} bgColor={"gray.gray200"} padding={"8px"} fontFamily="body" fontSize={"14px"} fontWeight={"500"} color={"#00000"} _hover={{ bgColor: "blue.blue100", borderRightRadius: "2px", color: "#fff"}}  cursor="pointer">
                <Box  fontSize={"20px"} pos="relative" top="-1px"><AiOutlineLogout/></Box>
                <Text textTransform={"capitalize"} >Logout</Text>
               </HStack>
              

            </Stack>


            
        </Box>
    )
}
